module.exports = __webpack_public_path__ + "img/changeAllocation-1@2x.ec2377a.png";